import { createTheme } from '@mui/material/styles';



export const theme = createTheme({
    status: {
      danger: '#e53e3e',
    },
    palette: {
      primary: {
        main: '#663cc1',//'#192a56', //#192a56d9
        // main: '#F4F5FA',
        darker: '#053e85',
      },
      secondary: {
        main: '#deaa86',
        darker: '#053e85',
        contrastText: '#121926'
      },
      neutral: {
        main: '#64748B',
        contrastText: '#fff',
      },
      text: {
        primary: '#2e263de6'
      },
      warning: {
        main: '#ed6c02',
        light: '#ff9800',
        dark: '#e65100'
      },
      success: {
        main: '#2e7d32',
        light: '#4caf50',
        dark: '#1b5e20'
      },
      error: {
        main: '#d32f2f',
        light: '#ef5350',
        dark: '#c62828'
      }
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            // backgroundColor: '#001d35d4',
            backgroundColor: 'rgb(238, 242, 246); ', // 'white',//'#192a56', //'#110a96d4',
            color: "#FFFF",
          },
        },
      },
    },
    
  });




declare module '@mui/material/styles' {
    interface Theme {
      status: {
        danger: React.CSSProperties['color'];
      };
    }
  
    interface ThemeOptions {
      status: {
        danger: React.CSSProperties['color'];
      };
    }
  
    interface Palette {
      neutral: Palette['primary'];
    }
  
    interface PaletteOptions {
      neutral: PaletteOptions['primary'];
    }
  
    interface PaletteColor {
      darker?: string;
    }
  
    interface SimplePaletteColorOptions {
      darker?: string;
    }
}